import React, { useEffect, useState } from "react";
import { Alert, AlertTitle, Link, Typography, Divider, Grid, Button } from "@mui/material";
import queryString from "query-string";
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";
import useWindowDimensions from "../../Utils/Hooks/useWindowDimensions";

export function CarePlanConfirmation(props) {
    const [numPages, setNumPages] = useState(null);
    const { height, width } = useWindowDimensions();

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    //get first name
    const value = queryString.parse(window.location.search);
    const firstName = atob(value.q);

    return (
        <Grid container align="center" alignItems="center" justifyContent="center" direction="column">
            <Grid item>
                <Alert
                    severity="success"
                    variant="filled"
                    sx={{
                        mt: {
                            xs: 3,
                            sm: 2,
                        },
                        mb: 2,
                        maxWidth: "md",
                    }}
                >
                    <AlertTitle>
                        <strong>Hi {firstName}, we found your care plan!</strong>
                    </AlertTitle>
                    <br />
                    <Typography>
                        Your care plan can be seen below, alternatively you can download the PDF by clicking{" "}
                        <strong>Download PDF</strong>.
                    </Typography>
                    <br />
                    <br />
                    <Divider />
                    <br />
                    <Typography>
                        If you need to, you can get in touch with us through our website -{" "}
                        <Link
                            href="https://www.connecthealth.co.uk/contact/"
                            target="_blank"
                            rel="noopener"
                            color="inherit"
                            underline="always"
                        >
                            https://www.connecthealth.co.uk/contact/
                        </Link>
                    </Typography>
                    <Typography>
                        You will also find information about your service, including opening times, services offered and
                        who your clinicians are, on our website.
                    </Typography>
                    <br />
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        type="button"
                        sx={{ color: "#fff" }}
                        onClick={() =>
                            localStorage.getItem("carePlan") && base64toPDF(localStorage.getItem("carePlan"))
                        }
                    >
                        <strong>Download PDF</strong>
                    </Button>
                </Alert>
            </Grid>

            <Grid item sx={{ border: "3px solid #bcbdc2" }}>
                {localStorage.getItem("carePlan") ? (
                    <Document
                        file={`data:application/pdf;base64,${localStorage.getItem("carePlan")}`}
                        onLoadSuccess={onDocumentLoadSuccess}
                    >
                        {Array.from(new Array(numPages), (element, i) => (
                            <>
                                <Page key={`Page ${i + 1}`} width={width > 1080 ? 1080 : width} pageNumber={i + 1} />
                                <Divider />
                            </>
                        ))}
                    </Document>
                ) : (
                    <Typography>
                        <strong> Unable to load PDF </strong>
                    </Typography>
                )}
            </Grid>

            <Button
                variant="contained"
                color="secondary"
                size="large"
                type="button"
                sx={{ color: "#fff", margin: "40px 0px 48px 0px" }}
                onClick={() => localStorage.getItem("carePlan") && base64toPDF(localStorage.getItem("carePlan"))}
            >
                <strong>Download PDF</strong>
            </Button>
        </Grid>
    );
}

function base64toPDF(data) {
    var bufferArray = base64ToArrayBuffer(data);
    var blobStore = new Blob([bufferArray], { type: "application/pdf" });
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blobStore);
        return;
    }
    var data = window.URL.createObjectURL(blobStore);
    var link = document.createElement("a");
    document.body.appendChild(link);

    //download PDF
    link.href = data;
    link.download = "CarePlan.pdf";
    link.click();
    window.URL.revokeObjectURL(data);
    link.remove();

    // Open PDF
    // window.open(data);
}

function base64ToArrayBuffer(data) {
    var bString = window.atob(data);
    var bLength = bString.length;
    var bytes = new Uint8Array(bLength);
    for (var i = 0; i < bLength; i++) {
        var ascii = bString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
}
